import React from 'react';
import Banner from '../components/Banner';
import Breadcrumb from '../components/Breadcrumb';
import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import '../styles/pages/Resources.css';
import ResourceBg from '../images/resource-bg.jpeg'
import { Link } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from "react-router-dom";
import newsData from "../data/newsData";
import { FiMapPin, FiMail, FiPhone } from "react-icons/fi";
import '../styles/pages/Contact.css';
import '../styles/pages/Industries.css';


const Resources = () => {

    const fadeUp = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1, y: 0,
            transition: { duration: 0.7, ease: "easeOut" }
        }
    };

    const navigate = useNavigate();


    const cardAnim = {
        hidden: { opacity: 0, y: 40 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6 }
        }
    };

    const container = {
        hidden: {},
        show: {
            transition: { staggerChildren: 0.15 }
        }
    };

    const item = {
        hidden: { opacity: 0, y: 50 },
        show: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (

        <motion.div
            initial={{ opacity: 0 }
            }
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
        >

            <SEO
                title="Resources"
                description="Resources - Fortune Cloud Solutions"
            />

            <Banner
                title="RESOURCES"
                image={ResourceBg}
            />


            <div className="resources-news pt-3">




                {/* ===== RESOURCES SECTION ===== */}

                <section className="container">
                    <Breadcrumb />

                    <div className="section-title">

                        <h2>LATEST RESOURCES</h2>

                        <p>
                            Read our latest updates and insights from Fortune Cloud Solutions.
                        </p>

                    </div>



                    <div className="row">


                        {newsData.map((item, index) => (

                            <div
                                key={index}
                                className="col-lg-4 col-md-6 mb-4"
                            >

                                <motion.div
                                    className="resource-card h-100"
                                    variants={cardAnim}
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true }}
                                    whileHover={{ y: -10 }}
                                    onClick={() => navigate(`/resources/${item.slug}`)}
                                >

                                    <div className="resource-img">

                                        <img
                                            src={item.image}
                                            alt={item.title}
                                        />

                                        <div className="img-overlay" />

                                        <span className="resource-category">
                                            {item.category || "Resources"}
                                        </span>

                                    </div>


                                    <div className="resource-content">

                                        <span className="resource-date">
                                            {item.date}
                                        </span>


                                        <h3>
                                            {item.title}
                                        </h3>


                                        <p>
                                            {item.desc}
                                        </p>


                                        <div className="read-more-row">

                                            <span className="read-btn">
                                                Read Article
                                            </span>

                                            <span className="arrow">
                                                →
                                            </span>

                                        </div>

                                    </div>

                                </motion.div>

                            </div>

                        ))}


                    </div>

                </section>

                {/* ===== CTA SECTION ===== */}
                <section className="about-cta-section">
                    <motion.div
                        className="container"
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, margin: "-80px" }}
                    >
                        <h2 className='text-uppercase'>Let Us Help Your Business Move Forward</h2>
                        <p>
                            Fortune Cloud Solutions provides tailored IT staffing, industry-relevant training,
                            and career development services, empowering businesses and professionals to thrive
                            in the ever-evolving IT landscape.
                        </p>
                        <Link to="/contact">
                            <button className="about-cta-btn text-uppercase">
                                Get In Touch <FaArrowRight className="ms-2" />
                            </button>
                        </Link>
                    </motion.div>
                </section>

            </div>


        </motion.div >
    );
};

export default Resources;